export default function Numpy_Quiz() {
  return <div>Numpy_Quiz Component</div>;
}
